<template lang="pug">
  .wrap
    JobListSidebar(:openSidebar="openSidebar" @toggleSidebar="toggleSidebar")

    .main
      .job-list
        .job-list-header(:class="{ 'job-list-header-fixed-sp': false }")
          JobListSortArea(
            @searchOrderBy="searchOrderBy"
            @toggleSidebar="toggleSidebar"
          )
        .job-list-body
          table.row-list.row-job-list
            JobListTableHeader(
              :checked="pageAllChecked",
              @check="togglePageCheck"
            )
            JobListTableRow(
              v-for="(v, i) in index",
              :job="v",
              :index="i",
              :key="v.id",
              :checkedIds="pageCheckedIds",
              :updateFavorForIndex="false",
              @display="displayDetailModal",
              @check="toggleCheck",
              @update="reloadOrUpdate"
            )
          JobListMenu(@remove="reload")
        Pagination(
          :pagination="pagination"
          @selectPerPage="selectPerPage"
          @selectPage="selectPage"
        )
      JobShowModal(
        :isOpened="openJobShowModal"
        :jobDetail="jobDetail"
        :updateFavorForIndex="false"
        @update="reloadOrUpdate"
        @hide="hideJobShowModal")
    Footer
</template>

<script>
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
  import { ErrorMessages } from '../constants'
  import JobListTableHeader from './parts/JobListTableHeader'
  import JobListTableRow from './parts/JobListTableRow'
  import JobListMenu from './parts/JobListMenu'
  import JobShowModal from './parts/JobShowModal'
  import JobListSidebar from './parts/JobListSidebar'
  import JobListSortArea from './parts/JobListSortArea'
  import Footer from './parts/Footer'
  import Pagination from './parts/Pagination'

  export default {
    components: {
      JobListTableHeader,
      JobListTableRow,
      JobListMenu,
      JobShowModal,
      JobListSidebar,
      JobListSortArea,
      Pagination,
      Footer,
    },
    async asyncData ({ store, route: { query } }) {
      if (!Object.keys(query).length) {
        throw new Error(ErrorMessages.NO_PARAMETER_SEARCH_JOB_LIST)
      }
      await store.dispatch('jobList/fetchIndex', query)
      await store.dispatch('client/fetch')
    },
    updated () {
      this.avoidBlank()
    },
    created () {
      this.avoidBlank()
    },
    data () {
      return {
        openJobShowModal: false,
        openSidebar: false,
      }
    },
    computed: {
      ...mapGetters('jobList', ['pageAllChecked']),
      ...mapGetters('common', ['spMode']),
      ...mapGetters('client', ['clientUsers']),
      ...mapState({
        pagination: state => state.jobList.pagination,
        index: state => state.jobList.index,
        pageCheckedIds: state => state.jobList.pageCheckedIds,
        jobDetail: state => state.job.detail,
      }),
      page () {
        return this.$route.query.page
      },
      perPage () {
        return this.$route.query.perPage
      },
    },
    methods: {
      ...mapMutations('jobList', ['check', 'uncheck']),
      ...mapActions('jobList', ['toggleCheck', 'togglePageCheck']),
      async searchOrderBy (target) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            order: target,
            page: '1',
            _t: Date.now(),
          },
        })
      },
      async selectPerPage (perPage) {
        this.reload({ perPage, page: '1' })
      },
      async selectPage (page) {
        this.reload({ page })
      },
      reload ({ perPage, page } = {}) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            perPage: perPage || query.perPage,
            page: page || query.page,
            _t: Date.now(),
          },
        })
      },
      reloadOrUpdate ({ id }) {
        if (this.spMode) {
          this.$store.dispatch('jobList/updateIndex', id)
        } else {
          this.reload()
        }
      },
      displayDetailModal ({ id }) {
        if (id !== this.jobDetail.id) {
          this.$store.dispatch('job/fetchDetail', { id })
            .then(() => {
              this.openJobShowModal = true
            })
        } else {
          this.openJobShowModal = !this.openJobShowModal
        }
      },
      hideJobShowModal () {
        this.openJobShowModal = false
      },
      avoidBlank () {
        const { query } = this.$route
        const page = parseInt(query.page, 10) || 1

        // 直近の fetchIndex がエラーで終わった場合は page-- しない。
        // 取得失敗で空配列になった画面で page-- を続けるとエラーループになる。
        if (this.$store.state.jobList.lastFetchError) return

        // 連射防止: API エラー時に暴走して連続リクエストを飛ばすのを防ぐ
        // eslint-disable-next-line no-underscore-dangle
        if (this._avoidBlankGuard) return

        if (!this.index.length && page > 1) {
          // eslint-disable-next-line no-underscore-dangle
          this._avoidBlankGuard = true
          // eslint-disable-next-line no-underscore-dangle
          setTimeout(() => { this._avoidBlankGuard = false }, 3000)
          this.$router.push({ query: { ...query, page: page - 1 } })
        }
      },
      toggleSidebar () {
        this.openSidebar = !this.openSidebar
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/JobList.vue